import { render } from "./SongsCard.vue?vue&type=template&id=6a0565e0"
import script from "./SongsCard.vue?vue&type=script&lang=js"
export * from "./SongsCard.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__